import { gql } from '@apollo/client';
import { useCreate, useUpdate } from '../../../utils/useUpdateCreate';
import {
  CreateSegmentMutation,
  SegmentCreationInput,
  SegmentUpdateInput,
  UpdateSegmentMutation,
} from '../../../__generated__/queries-web';
import { GET_SEGMENTS } from '../segmentList/getSegments.web.graphql';
import { GET_SEGMENT } from './getSegment.web.graphql';

const UPDATE_SEGMENT = gql`
  mutation UpdateSegment(
    $where: SegmentUniqueFilterInput!
    $data: SegmentUpdateInput!
  ) {
    updateSegment(where: $where, data: $data) {
      id
    }
  }
`;

export const useUpdateSegment = (message?: string) =>
  useUpdate<UpdateSegmentMutation, SegmentUpdateInput>(
    UPDATE_SEGMENT,
    [GET_SEGMENT, GET_SEGMENTS],
    message,
  );

const CREATE_SEGMENT = gql`
  mutation CreateSegment($data: SegmentCreationInput!) {
    createSegment(data: $data) {
      id
    }
  }
`;

export const useCreateSegment = () =>
  useCreate<CreateSegmentMutation, SegmentCreationInput>(CREATE_SEGMENT, [
    GET_SEGMENTS,
  ]);
